module.exports = __webpack_public_path__ + "static/media/11.ba640120.JPG";